import { Box, Chip, Tooltip } from "@mui/material";
import StarIcon from '@mui/icons-material/StarOutline';
import { LikeChip } from "./LikeChip";
import { CommentChip } from "./CommentChip";
import { ActionCountRow } from "./ui/ActionCounts";
import { getActionStats } from "../utils/itemUtil";

// Secondary social stats: likes, comments, points and pending state.
export const ItemSocialStats = ({ item, showComments = true }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '6px', alignItems: "center", flexWrap: 'wrap' }}>
            <LikeChip key={item.id} itemId={item.id} initialCount={item.likeCount} isLikedByUser={item?.likedByUser} />
            {showComments ? <CommentChip count={item.commentCount} /> : null}
            <Tooltip title="Points" placement="top" arrow>
                <Chip size="small" variant="outlined" label={`${item?.points || 0}`} icon={<StarIcon fontSize="small" />} aria-label={`${item?.points || 0} points`} />
            </Tooltip>
            {item.isPending ? <Chip label="Pending approval" size="small" color="warning" /> : null}
        </Box>
    );
}

// Aggregate action counts followed by social stats.
export const ItemStats = ({ item, showActions = true }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {showActions ? <ActionCountRow stats={getActionStats(item)} /> : null}
            <ItemSocialStats item={item} />
        </Box>
    );
}
